var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12 1a1 1 0 0 1 .944.67l7 20a1 1 0 0 1-1.525 1.144l-6.42-4.585-6.418 4.585a1 1 0 0 1-1.525-1.144l7-20A1 1 0 0 1 12 1z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }